// extracted by mini-css-extract-plugin
export default {"List":"values_List__tcr0M","Value":"values_Value__iLuWP"};